import PermissionPage from './PermissionPage';
import { connect } from 'react-redux';
import { fetchPermissions } from '../../../actions/permission_actions';
import { bindActionCreators } from 'redux';
import { completeRequest } from '../../../actions/request_state';

function mapStateToProps(state) {
  return {
    permissions: state.permissions.permissions,
    requestPermissionsAdminSend: state.requestState.requestPermissionsAdminSend,
    meta: state.permissions.meta,
    canEditPermissionAdmin:
      state.authentication.currentUser.canEditPermissionAdmin,
    requestErrorsOnSavePermission:
      state.requestState.requestErrorsOnSavePermission
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchPermissions: bindActionCreators(fetchPermissions, dispatch),
    completeRequest: bindActionCreators(completeRequest, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionPage);
